<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="300"
  >
    <v-card>
      <v-card-title>
        <h2>{{ title }}</h2>

        <v-spacer />

        <v-icon
          aria-label="Close"
          @click="cancel"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text class="pb-6 pt-6 black--text">
        {{ content }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="error"
          dark
          @click="confirm"
        >
          네
        </v-btn>

        <v-btn
          @click="cancel"
        >
          아니오
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConfirmDialog',
    props: {
      title: {
        type: String,
      },
      content: {
        type: String,
      },
      dialog: {
        type: Boolean,
        default: false,
      },
      toParent: {
        type: Function,
      },
    },
    methods: {
      confirm () {
        this.toParent('ok')
      },
      cancel () {
        this.toParent('cancel')
      },
    },
  }
</script>

<style scoped>

</style>
